module.exports = __webpack_public_path__ + "static/media/Rabbit-web-logo.b7a8e1b2.png";